import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { JWT_SERVICE } from '@core/services';
import { AccessDeniedPath } from '@core/constants';

/**
 * The Evaluation Guard checks the guest's accessIdentifier against the Evaluation Task ID to see if they're currently allowed to view the given Evaluation Task.
 * If not, they are redirected to the Access Denied page.
 *
 * This should be called after the guestGuard in the canActivate array.
 *
 * All needed information is taken from the route and localStorage, so the Evaluation Service is not called or needed at this point.
 */
export const evaluationGuard: CanActivateFn = (route) => {
  const _router = inject(Router);
  const jwtService = inject(JWT_SERVICE);
  const guestFromJWT = jwtService.getJwtData();
  const evalKey: number = Number(route.paramMap?.get('evalId'));

  if (guestFromJWT?.accessIdentifier === evalKey) {
    return true;
  } else {
    console.error('Invalid Evaluation.');
    return _router.createUrlTree([AccessDeniedPath]);
  }
};
